<style>
  .fix-static-bug {
    width: 100% !important;
    position: static !important;
  }

  .grey {
    color: #383838;
  }

  .padding30 {
    padding: 16px;
  }

  .link {
    float: right;
    margin-right: 20px;
    position: relative;
    top: 15px;
  }

  .infotext {
    padding-left: 15px;
    font-size: 80%;
    margin-top: -15px;
    padding-bottom: 15px;
  }

  .summary-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .admin-view-button {
    margin-left: 15px;
  }

  .person {
    float: right;
  }

  .infoicon {
    font-size: 16px;
    position: relative;
    top: 5px;
  }

  .save-button-info {
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
  }

  .save-button-info .infoicon {
    top: 3px;
    vertical-align: middle;
  }

  .light-grey {
    color: lightgrey;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2; /* Light grey color */
  }

  .card-field-row {
    margin-left: 0;
    margin-right: 0;
  }

  .card-field-row .mat-form-field {
    margin-bottom: 8px;
  }

  .tight-columns {
    margin-left: -7.5px;
    margin-right: -7.5px;
  }

  .tight-columns > [class^="col-"],
  .tight-columns > [class*=" col-"] {
    padding-left: 7.5px;
    padding-right: 7.5px;
  }

  .fix-static-bug mat-card {
    display: flow-root;
    /*padding: 16px;*/
  }

  .card-stack {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .card-stack mat-card {
    margin: 0;
  }

  .card-gap-row > [class^="col-"],
  .card-gap-row > [class*=" col-"] {
    margin-bottom: 16px;
  }

  .fix-static-bug ::ng-deep .no-subscript .mat-mdc-form-field-subscript-wrapper {
    display: none;
    height: 0;
    margin: 0;
    padding: 0;
  }

  .tabbable-static-value {
    width: 100%;
    border: 0;
    background: transparent;
    padding: 0;
    color: inherit;
  }

  .tabbable-static-value:focus {
    outline: 1px solid #808080;
    outline-offset: 2px;
  }

  .tabbable-static-value.bold-value {
    font-weight: 700;
  }

  textarea.tabbable-static-value {
    resize: none;
    overflow: hidden;
    white-space: pre-wrap;
  }

</style>

<div class="fix-static-bug">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h3 class="main-heading sam-page-heading">Inbetalning</h3>
      </div>
    </div>

    <div *ngIf="isLoading" role="status">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p>Laddar inbetalningsunderlaget...</p>
    </div>
    <div *ngIf="loadError" role="alert">
      <p>{{loadError}}</p>
      <button mat-stroked-button type="button" (click)="loadInvoice(id)">Försök igen</button>
    </div>

    <!--Calculate partial total amount / gross salary-->
    <div *ngIf="!isLoading && invoice && !loadError" class="row align-items-start tight-columns" style="background-color: #f3f3f3; padding: 20px 10px;">

      <div *ngIf="invoice.ExpressPayOut && invoice.ApprovedForExpress" class="col-12" style="margin-bottom: 10px;">
        <b style="color: green;">Godkänd för expressutbetalning</b><br />
      </div>
      <div *ngIf="invoice.ExpressPayOut && !invoice.ApprovedForExpress" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Ej godkänd för expressutbetalning</b><br />
      </div>
      <div *ngIf="invoice?.AdminInfo != ''" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">{{invoice?.AdminInfo}}</b><br />
      </div>

      <!--Invoice info-->
      <div class="col-sm-12 col-md-6">
        <div class="card-stack">
          <mat-card>
          <mat-card-title>
            Fakturainfo
            <span *ngIf="invoice.SubInvoice" class="person" matTooltipPosition="after" aria-label="Underfaktura" matTooltip="Detta är en underfaktura"><mat-icon>{{invoice.Type?.TechnicalName === 'CommissionCashInvoice' ? 'compare_arrows' : invoice.RecipientOrganizationId ? 'business' : 'person'}}</mat-icon></span>
            <span *ngIf="invoice.ParentInvoice" class="person" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Detta är en moderfaktura"><mat-icon>groups</mat-icon></span>
          </mat-card-title>

          <div class="row card-field-row">
            <mat-form-field class="col-12">
              <mat-label>Fakturamottagare</mat-label>
              <input type="text" [ngModel]="invoice.Customer.Name" matInput disabled />
            </mat-form-field>

            <mat-form-field class="col-6">
              <mat-label>Fakturanummer</mat-label>
              <input type="text" [(ngModel)]="invoice.InvoiceNumber" matInput disabled />
            </mat-form-field>

            <mat-form-field class="col-6">
              <mat-label>Faktura-id</mat-label>
              <input type="text" [(ngModel)]="invoice.Id" matInput disabled />
            </mat-form-field>
          </div>

          <mat-form-field class="col-12">
            <mat-label>OCR</mat-label>
            <input type="text" [(ngModel)]="invoice.Ocr" matInput disabled />
          </mat-form-field>

          <mat-form-field class="col-5">
            <mat-label>Inbetalningsdatum</mat-label>
            <input matInput [matDatepicker]="pickerInPayment" [(ngModel)]="invoice.PaymentDate" (dateChange)="invoice.PaymentDate = toFormattedDate($event.value)">
            <mat-datepicker-toggle matSuffix [for]="pickerInPayment"></mat-datepicker-toggle>
            <mat-datepicker #pickerInPayment></mat-datepicker>
          </mat-form-field>

          <!-- PaidTotal is pre-set to the total invoice amount inc vat, which is set when invoice is sent -->
          <mat-form-field class="col-5">
            <mat-label>Totalt inbetalt från kund</mat-label>
            <input type="number" maxlength="10" [ngModel]="invoice.PaidTotal" (ngModelChange)="invoice.PaidTotal=$event; updateAmounts();" matInput />
          </mat-form-field>

          <span class="col-2">
            SEK
          </span>
          <mat-form-field *ngIf="invoice.Currency?.Name && invoice.Currency.Name !== 'SEK'" class="col-10">
            <mat-label>Valutakurs inbetalning</mat-label>
            <input matInput disabled [value]="invoice.ExchangeRateInvoicePaid | number:'1.4-4'" />
          </mat-form-field>
          <mat-form-field class="col-10">
            <mat-label>Totalt fakturerat inkl. moms</mat-label>
            <input type="number" [ngModel]="invoice.TotalInvoiceAmountIncVat" (ngModelChange)="invoice.TotalInvoiceAmountIncVat=$event" name="TotalInvoiceAmountIncVat" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            {{invoice.Currency.Name}}
          </span>
          <mat-form-field class="col-10">
            <mat-label>Totalt fakturerad moms</mat-label>
            <input type="number" [ngModel]="invoice.TotalVatAmount" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            {{invoice.Currency.Name}}
          </span>

          <mat-form-field class="col-10">
            <mat-label>Fakturaavgift</mat-label>
            <input type="number" [ngModel]="InvoiceFeeReceiver" matInput disabled />
            <mat-hint *ngIf="invoice.InvoiceFeeDiscount" style="color:green;">
              {{invoice.InvoiceFeeDiscount.Code}} {{invoice.InvoiceFeeDiscount.Category == 0 ? invoice.InvoiceFeeDiscount.DiscountPercentage + '% rabatt' : invoice.InvoiceFeeDiscount.FixedDiscountAmount + ' kr rabatt'}}
            </mat-hint>
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>

          <div>
            <mat-form-field class="col-10">
              <mat-label>Totalt fakturerat exkl. moms</mat-label>
              <input type="number" [ngModel]="invoice.TotalInvoiceAmount" matInput disabled />
            </mat-form-field>
            <span class="col-2">
              {{invoice.Currency.Name}}
            </span>
          </div>
        </mat-card>
        <mat-card class="grey padding30">
          <mat-checkbox matInput [ngModel]="InvoiceFeePaidByCustomer" (change)="changeValue($event)">Kunden har betalat fakturaavgiften</mat-checkbox>
        </mat-card>
        <mat-card>
          <mat-form-field class="col-12 no-subscript" style="margin: 15px 0;">
            <mat-label>Fritext / kommentar</mat-label>
            <input type="text" [(ngModel)]="invoice.FeeDescription" matInput />
          </mat-form-field>
        </mat-card>
        </div>
      </div>

      <!--Fees added to invoice-->
      <div class="col-sm-12 col-md-6">
        <div class="card-stack">
          <mat-card>
          <mat-card-title>Avgifter (dras från fakturerat belopp)</mat-card-title>

          <mat-form-field class="col-10">
            <mat-label>{{invoice.RecipientOrganizationId ? 'Fakturaavgift mottagare' : 'Fa.avgift medlem'}}</mat-label>
            <mat-icon *ngIf="!invoice.InvoiceFeeUnlocked && !invoice.FeePaidByReciever" (click)="invoice.InvoiceFeeUnlocked = !invoice.InvoiceFeeUnlocked" after matSuffix style="cursor: pointer;">lock</mat-icon>
            <mat-icon *ngIf="invoice.InvoiceFeeUnlocked  && !invoice.FeePaidByReciever" (click)="invoice.InvoiceFeeUnlocked = !invoice.InvoiceFeeUnlocked" after color="accent" matSuffix style="cursor: pointer;">lock_open</mat-icon>
            <input type="number" [disabled]="!invoice.InvoiceFeeUnlocked" [ngModel]="InvoiceFeeMember" (change)="updateAmounts()" (ngModelChange)="invoice.InvoiceFee=$event; InvoiceFeeMember=$event;" matInput />
            <mat-hint *ngIf="invoice.InvoiceFeeDiscount" style="color:green;">
              {{invoice.InvoiceFeeDiscount.Code}} {{invoice.InvoiceFeeDiscount.Category == 0 ? invoice.InvoiceFeeDiscount.DiscountPercentage + '% rabatt' : invoice.InvoiceFeeDiscount.FixedDiscountAmount + ' kr rabatt'}}
            </mat-hint>
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>

          <mat-form-field class="col-10">
            <mat-label>SAMpoolen-avgift</mat-label>
            <mat-icon *ngIf="!invoice.ServiceFeeUnlocked" (click)="invoice.ServiceFeeUnlocked = !invoice.ServiceFeeUnlocked" after matSuffix style="cursor: pointer;">lock</mat-icon>
            <mat-icon *ngIf="invoice.ServiceFeeUnlocked" (click)="invoice.ServiceFeeUnlocked = !invoice.ServiceFeeUnlocked" after color="accent" matSuffix style="cursor: pointer;">lock_open</mat-icon>
            <input type="number" [disabled]="!invoice.ServiceFeeUnlocked" [ngModel]="invoice.ServiceFee" (ngModelChange)="invoice.ServiceFee=$event" matInput (change)="updateAmounts()" />
            <mat-hint *ngIf="invoice.ServiceFeeDiscount" style="color:green;">
              {{invoice.ServiceFeeDiscount.Code}} {{invoice.ServiceFeeDiscount.Category == 0 ? invoice.ServiceFeeDiscount.DiscountPercentage + '% rabatt' : invoice.ServiceFeeDiscount.FixedDiscountAmount + ' kr rabatt'}}
            </mat-hint>
          </mat-form-field>

          <span class="col-2">
            SEK
          </span>

          <div class="col-10" style="margin: -15px 0 15px 0; font-size: 80%;">
            {{ServiceFeeInfo}}

          </div>
          <mat-form-field *ngIf="invoice.RecipientOrganizationId && invoice.ServiceFeeVat" class="col-10">
            <mat-label>Moms på SAMpoolen-avgift</mat-label>
            <input type="number" [ngModel]="invoice.ServiceFeeVat" matInput disabled />
          </mat-form-field>
          <span *ngIf="invoice.RecipientOrganizationId && invoice.ServiceFeeVat" class="col-2">SEK</span>
          <mat-form-field class="col-10">
            <mat-label>Bankavgift</mat-label>
            <mat-icon *ngIf="!invoice.ExchangeFeeUnlocked" (click)="invoice.ExchangeFeeUnlocked = !invoice.ExchangeFeeUnlocked" after matSuffix style="cursor: pointer;">lock</mat-icon>
            <mat-icon *ngIf="invoice.ExchangeFeeUnlocked" (click)="invoice.ExchangeFeeUnlocked = !invoice.ExchangeFeeUnlocked" after color="accent" matSuffix style="cursor: pointer;">lock_open</mat-icon>
            <input type="number" [disabled]="!invoice.ExchangeFeeUnlocked" [ngModel]="invoice.ExchangeFee" (ngModelChange)="invoice.ExchangeFee=$event" matInput (change)="updateAmounts()" />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Påminnelseavgift</mat-label>
            <input type="number" [ngModel]="invoice.ReminderFee" (ngModelChange)="invoice.ReminderFee=$event" matInput (change)="updateAmounts()" />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Inkassoavgift</mat-label>
            <input type="number" [ngModel]="invoice.InkassoFee" (ngModelChange)="invoice.InkassoFee=$event" matInput (change)="updateAmounts()" />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Avgift Kronofogden</mat-label>
            <input type="number" [ngModel]="invoice.KronofogdenFee" (ngModelChange)="invoice.KronofogdenFee=$event" matInput (change)="updateAmounts()" />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Manuell avgift</mat-label>
            <input type="number" [ngModel]="invoice.CustomFee" (ngModelChange)="invoice.CustomFee=$event" matInput (change)="updateAmounts()" />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Manuell rabatt eller gåva</mat-label>
            <input type="number" [ngModel]="invoice.ManualDiscount" (ngModelChange)="invoice.ManualDiscount = $event; updateAmounts()" matInput />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
        </mat-card>
        <mat-card style="padding-top: 15px;">
          <mat-form-field class="col-10">
            <mat-label>Summa avgifter (inkl kunds ev fakturaavgift)</mat-label>
            <input type="number" [ngModel]="invoice.FeesTotalAmount" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Manuell rabatt</mat-label>
            <input type="number" [ngModel]="invoice.ManualDiscount" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <div>
            <mat-form-field class="col-10">
              <mat-label>{{invoice.RecipientOrganizationId ? 'Delsumma efter avgifter' : 'Delsumma (lönegrundande belopp + nettoersättningar)'}}</mat-label>
              <input type="number" [value]="PartialTotalAmount" [(ngModel)]="PartialTotalAmount" matInput disabled />
            </mat-form-field>
            <span class="col-2">
              SEK
            </span>
          </div>
        </mat-card>
        </div>
      </div>
      <!-- If a payment date is set, a transaction log is created, otherwise it is just saved -->
      <div class="col-lg-12 col-sm-12" style="margin-top: 10px; padding-right: 25px; float: left;">
        <button mat-flat-button color="accent" (click)="save(invoice)" [disabled]="isLoading" style="float:right; display: block;">Spara endast inbetalning <span class="save-button-info" matTooltipPosition="below" aria-label="Information om sparandet" matTooltip="Sparar inbetalning och avgifter utan att ändra underfakturornas utbetalningsdatum." style="display: inline-flex; align-items: center; margin-left: 6px;"><mat-icon class="infoicon" style="position: static; width: 16px; height: 16px; font-size: 16px; line-height: 16px;">info</mat-icon></span></button>
        <a href="#/transactions" class="link">Gå till Ekonomi</a>
      </div>


    </div>


    <!-- Kept inactive: this page only registers incoming payments. -->
    <ng-container *ngIf="subInvoicePayoutsEnabled">
    <!--   ***********   -->
    <!--   UTBETALNING   -->
    <!--   ***********   -->

    <div class="col-md-12">
      <h3 class="main-heading" style="margin-top: 20px;">Utbetalningar</h3>
    </div>

    <div *ngFor="let subInvoice of invoice?.SubInvoices">
      <mat-card *ngIf="!isLoading && subInvoice.RecipientOrganizationId">
        <h3>{{subInvoice.Type?.TechnicalName === 'CommissionCashInvoice' ? 'Provision' : 'Ersättning/delning'}} – {{subInvoice.UserSettings?.CompanyName}}</h3>
        <p>Faktura {{subInvoice.InvoiceNumber}} · {{subInvoice.Status?.Name}}</p>
        <p>Belopp: {{subInvoice.TotalInvoiceAmount | number:'1.0-2'}} {{invoice.Currency?.Name}}</p>
        <p>Serviceavgift: {{subInvoice.ServiceFee | number:'1.0-2'}} · Moms på serviceavgift: {{subInvoice.ServiceFeeVat | number:'1.0-2'}}</p>
      </mat-card>
      <div *ngIf="!isLoading && !subInvoice.RecipientOrganizationId" class="row align-items-end" style="background-color: #f3f3f3; margin-top: 20px; padding-top: 20px; padding-bottom: 30px;">
        <!--For commission invoice-->
        <div *ngIf="subInvoice?.Type != null">
          <div class="row" *ngIf="subInvoice?.Type?.TechnicalName == 'CommissionCashInvoice'">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="row col-lg-12">
                <div class="col-sm-6 col-md-6 col-lg-3">
                  <h3>Provision</h3>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="row col-12">
                <div class="col-sm-6 col-md-6 col-lg-3">Fakturanummer: {{subInvoice?.InvoiceNumber}}</div>
                <div class="col-sm-6 col-md-6 col-lg-3">Faktura-id: {{subInvoice?.Id}} </div>
                <div class="col-sm-12 col-md-12 col-lg-3">Namn: {{subInvoice?.UserSettings?.CompanyName}}</div>
              </div>
            </div>

            <div class="col-sm-12 col-md-6 col-lg-6">
              <mat-card style="min-height: 350px;">
                <div class="row col-12">
                  <span class="col-sm-6 col-md-6 col-lg-6">Provisionsbelopp</span><span class="col-sm-6 col-md-6 col-lg-6"><strong>{{subInvoice.Commission | number: '1.0-3'}}</strong></span>
                </div>
                <div class="row col-12">
                  <span class="col-sm-6 col-md-6 col-lg-6">Provisionsprocent</span><span class="col-sm-6 col-md-6 col-lg-6"><strong>{{invoice?.Commission * 100}} %</strong></span>
                </div>
                <div class="row col-12">
                  <span class="col-sm-6 col-md-6 col-lg-6">Delsumma utan nettoersättningar</span><span class="col-sm-6 col-md-6 col-lg-6"><strong>{{PartialAmountExclNetExpenses | number}}</strong></span>
                </div>
                <div class="row col-12">
                  <span class="col-sm-6 col-md-6 col-lg-6">Provisionsberäkning</span><span class="col-sm-6 col-md-6 col-lg-6"><strong>{{PartialAmountExclNetExpenses | number: '1.0-2'}} x {{invoice?.Commission  | number: '1.0-3'}} = {{invoice?.Commission * PartialAmountExclNetExpenses | number: '1.0-0'}}</strong></span>
                </div>
              </mat-card>
            </div>

            <div class="col-sm-12 col-md-6 col-lg-6">
              <mat-card style="min-height: 350px;">
                <div class="row col-lg-12" style="margin: 0 0 20px -15px">

                  <div class="col-sm-6 col-md-6 col-lg-6">Bank:</div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.UserSettings?.BankName }} </div>
                  <div class="col-sm-6 col-md-6 col-lg-6" *ngIf="subInvoice?.UserSettings?.ClearingNumber != '3300'">Clearing + kontonummer: </div><div class="col-sm-6 col-md-6 col-lg-6" *ngIf="subInvoice?.UserSettings?.ClearingNumber != '3300'">{{ subInvoice?.UserSettings?.ClearingNumber }} {{ subInvoice?.UserSettings?.AccountNumber }}</div>
                  <div class="col-sm-6 col-md-6 col-lg-6" *ngIf="subInvoice?.UserSettings?.ClearingNumber == '3300'">Personkonto: </div><div class="col-sm-6 col-md-6 col-lg-6" *ngIf="subInvoice?.UserSettings?.ClearingNumber == '3300'">{{ subInvoice?.UserSettings?.AccountNumber }}</div>
                  <div class="col-sm-6 col-md-6 col-lg-6">Totalt att betala ut:</div><div class="col-sm-6 col-md-6 col-lg-6"><b>{{ subInvoice?.TotalPayout }}</b> </div>
                  <div class="col-sm-6 col-md-6 col-lg-6">Bankgiro: </div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.UserSettings?.Bankgiro }}</div>
                  <div class="col-sm-6 col-md-6 col-lg-6">Plusgiro: </div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.UserSettings?.Plusgiro }}</div>
                  <div class="col-sm-6 col-md-6 col-lg-6">BIC: </div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.UserSettings?.Bic }}</div>
                  <div class="col-sm-6 col-md-6 col-lg-6">IBAN: </div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.UserSettings?.Iban }}</div>
                  <div class="col-sm-6 col-md-6 col-lg-6">Text avsändarkonto: </div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.UserSettings?.EmploymentNumber }} {{ subInvoice?.InvoiceNumber }}<span *ngIf="invoice.ApprovedForExpress && subInvoice.ExpressPayOut">x</span> </div>
                  <div class="col-sm-6 col-md-6 col-lg-6">Text mottagarkonto: </div><div class="col-sm-6 col-md-6 col-lg-6">sam{{invoice?.InvoiceNumber}}</div>
                </div>

                <div class="row col-lg-12" style="margin: 0 0 20px -15px">
                  <div class="col-sm-12 col-md-6 col-lg-6">
                    <mat-form-field>
                      <input matInput [matDatepicker]="pickerPayment" [(ngModel)]="subInvoice.PayoutDate" (dateChange)="subInvoice.PayoutDate = toFormattedDate($event.value)" placeholder="Datum för utbetalning:">
                      <mat-datepicker-toggle matSuffix [for]="pickerPayment"></mat-datepicker-toggle>
                      <mat-datepicker #pickerPayment></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-6">
                    <button *ngIf="subInvoice" color="accent" mat-flat-button (click)="updatePayoutDate(subInvoice.Id, subInvoice.PayoutDate)" [disabled]="isLoading || subInvoice.PayoutDate == null" style="float:right;">Spara datum</button>
                  </div>

                  <div *ngIf="subInvoice.ExpressPayOut && !invoice.ApprovedForExpress" style="color: red; font-size: 80%; padding-left: 15px; font-style: italic;">
                    Expressutbetalning är vald, men moderfakturan är ej bekräftad
                  </div>
                </div>
              </mat-card>
            </div>
          </div>
        </div>
        <!-- For regular sub invoices -->
        <div class="row" *ngIf="subInvoice.Type == null || subInvoice?.Type?.TechnicalName != 'CommissionCashInvoice'">

          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="row col-lg-12">
              <div class="col-sm-6 col-md-6 col-lg-3">
                <h3>Löneutbetalning</h3>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-12 col-lg-12">
            <span class="col-sm-6 col-md-6 col-lg-3" *ngIf="subInvoice.ExpressPayOut"><strong style="color: red;">Express</strong></span>
            <span class="col-sm-6 col-md-6 col-lg-3" *ngIf="subInvoice?.UserSettings?.TaxAdjusted >= 0"><strong style="color: green;">Skatten är justerad</strong></span>
            <span class="col-sm-6 col-md-6 col-lg-3" *ngIf="subInvoice?.HasUnhandledTaxAdjustments"><strong style="color: red;">Ohanterad</strong></span>
            <span class="col-sm-6 col-md-6 col-lg-3" *ngIf="subInvoice?.UserSettings?.AttachmentOfSalaries.length != 0 && subInvoice?.UserSettings?.AttachmentOfSalaries.length > 0"><strong style="color: red;">Medlemmen har löneutmätning</strong></span>
            <span class="col-sm-6 col-md-6 col-lg-3" *ngIf="subInvoice?.HasUnhandledDeductions" style="margin-bottom: 10px;"><b style="color: red;">Det finns ohanterade utlägg</b><br /></span>
            <span class="col-sm-6 col-md-6 col-lg-3" *ngIf="subinvoice?.UserSettings?.AdminInfo != ''" style="margin-bottom: 10px;"><b style="color: red;">{{subinvoice?.UserSettings?.AdminInfo}}</b><br /></span>
          </div>

          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="row col-12">
              <div class="col-sm-6 col-md-6 col-lg-3">Fakturanummer: {{subInvoice?.InvoiceNumber}}</div>
              <div class="col-sm-6 col-md-6 col-lg-3">Faktura-id: {{subInvoice?.Id}} </div>
                  
              <div class="col-sm-12 col-md-12 col-lg-3">Namn: <a href="#" (click)="openUserSettings(subInvoice?.UserSettings?.Guid, $event)"> {{subInvoice?.UserSettings?.FirstName}} {{subInvoice?.UserSettings?.LastName}} </a> </div>
              <div class="col-sm-6 col-md-2 col-lg-3">Anställningsnr: {{subInvoice?.UserSettings?.EmploymentNumber}} </div>
              <div class="col-sm-6 col-md-6 col-lg-3">Delsumma: <strong>{{subInvoice?.PartialTotalAmount}}</strong> SEK</div>
              <div class="col-sm-6 col-md-6 col-lg-6">(Avdragen SAMpoolen-avgift: {{subInvoice?.ServiceFee}} SEK {{ServiceFeeInfo}})</div>
              <!-- </mat-card>-->
            </div>
          </div>

          <div class="col-sm-12 col-md-6 col-lg-6">
            <mat-card style="min-height: 350px;">
              <div class="row col-12">

                <span class="col-sm-6 col-md-6 col-lg-6">Privata avdrag</span><span class="col-sm-6 col-md-6 col-lg-6">{{subInvoice?.DeductionsTotalAmount}}</span>
                
                <span *ngIf="subInvoice?.DeductionsTotalAmount > 0" class="col-sm-6 col-md-6 col-lg-6">Varav friskvårdsavdrag</span><span *ngIf="subInvoice?.DeductionsTotalAmount > 0"class="col-sm-6 col-md-6 col-lg-6">{{subInvoice?.TotalHealthCareDeductionAmountThisInvoice}}</span>

                <div *ngIf="subInvoice?.TotalHealthCareDeductionAmountThisInvoice > 0" class="col-sm-12 col-md-12 col-lg-12" style="margin-bottom: 10px; font-size: 80% !important; font-style: italic;">
                  <span *ngIf="subInvoice.HealthCareAmountExceedesLimit" style="color: red;">Avdragen överstiger 5000 SEK. </span>
                  <span>Tidigare utbetalt för friskvård innevarande år: {{subInvoice.TotalHealthCareDeductionAmountThisYear}} SEK</span>
                </div>

                <span class="col-sm-6 col-md-6 col-lg-6">Traktamenten</span><span class="col-sm-6 col-md-6 col-lg-6">{{subInvoice?.AllowancesTotalAmount}}</span>
                <span class="col-sm-6 col-md-6 col-lg-6">Milersättning</span><span class="col-sm-6 col-md-6 col-lg-6">{{subInvoice?.MileageTotalAmount}}</span>
                <span class="col-sm-6 col-md-6 col-lg-6">Summa nettoersättningar</span><span class="col-sm-6 col-md-6 col-lg-6">{{subInvoice?.ExpensesTotalAmount}}</span>
                <br /><br />
                <span class="col-sm-6 col-md-6 col-lg-6">Lönegrundande belopp</span><span class="col-sm-6 col-md-6 col-lg-6"><strong>{{subInvoice?.PartialAmountExclNetExpenses}}</strong></span>
                <br /><br />
                <span class="col-sm-6 col-md-6 col-lg-6">Arbetsgivaravgift</span><span class="col-sm-3 col-md-3 col-lg-3">{{subInvoice?.ArbetsgivarAvgift}}</span><span class="col-sm-3 col-md-3 col-lg-3">{{subInvoice?.UserSettings?.EmployerTax?.Tax * 100 | number: '1.0-2'}} %</span>
                <span class="col-sm-6 col-md-6 col-lg-6">Bruttolön</span><span class="col-sm-6 col-md-6 col-lg-6">{{subInvoice?.BruttoLon}}</span>
                <span class="col-sm-6 col-md-6 col-lg-6">Kommunalskatt</span><span class="col-sm-3 col-md-3 col-lg-3">{{subInvoice?.PayoutMunicipalityTax}}</span>
                <span class="col-sm-3 col-md-3 col-lg-3" *ngIf="subInvoice.UserSettings.TaxAdjusted < 0">{{ subInvoice?.UserSettings?.Municipality?.Tax * 100  | number: '1.2-2'}} %</span>
                <span class="col-sm-3 col-md-3 col-lg-3" *ngIf="subInvoice.UserSettings.TaxAdjusted >= 0">{{ subInvoice?.UserSettings?.TaxAdjusted * 100  | number: '1.2-2'}} %</span>
                <span class="col-sm-6 col-md-6 col-lg-6">Nettolön</span><span class="col-sm-6 col-md-6 col-lg-6">{{subInvoice?.NettoLon}}</span>
                <span class="col-lg-12" *ngIf="subInvoice?.UserSettings?.HasCoordinationNumber" style="margin-top: 15px; font-size: 80%; font-style: italic;">Medlemmen har samordningsnummer. Angivet födelseår: {{ subInvoice?.UserSettings?.BirthYear }}</span>
              </div>
            </mat-card>
          </div>

          <div class="col-sm-12 col-md-6 col-lg-6">
            <mat-card style="min-height: 350px;">
              <div class="row col-lg-12" style="margin: 0 0 20px -15px">
                <div class="row col-12 marginbottom15">
                  <span class="col-sm-6 col-md-6 col-lg-6">Nettolön</span><span class="col-6">{{subInvoice?.NettoLon}}</span>
                  <span class="col-sm-6 col-md-6 col-lg-6">Summa nettoersättningar</span><span class="col-sm-6 col-md-6 col-lg-6">{{subInvoice?.ExpensesTotalAmount}}</span>
                  <span class="col-sm-6 col-md-6 col-lg-6">Beräkning utbetalning</span><span class="col-sm-6 col-md-6 col-lg-6">{{subInvoice?.PayOutTotal}}</span>
                </div>
                <br /><br />

                <!--<div class="row redbordercalc" *ngIf="subInvoice.AttachmentOfSalary.AttachmentAmount > 0">
                  <h4 class="col-lg-12">Utmätning av lön</h4>
                  <div class="col-sm-6 col-md-6 col-lg-6">Total nettolön denna månad:</div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.AttachmentOfSalary?.TotalSalaryPayoutThisMonth }}</div>
                  <div class="col-sm-6 col-md-6 col-lg-6">Totalt utmätt denna månad:</div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.AttachmentOfSalary?.TotalAttachmentPayoutThisMonth}} </div>
                  <div class="col-sm-6 col-md-6 col-lg-6">Reservationsbelopp:</div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.AttachmentOfSalary?.ReservedAmount }}</div>
                  <div class="col-sm-6 col-md-6 col-lg-6">Utmätningsbelopp:</div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.AttachmentOfSalary?.AttachmentAmount}} </div>
                </div>-->

                <div class="row col-12 marginbottom15">
                  <!--<div class="col-sm-6 col-md-6 col-lg-6">Totalt att betala ut:</div><div class="col-sm-6 col-md-6 col-lg-6"><b>{{ subInvoice?.PayOutTotal }}</b> </div>-->
                  <div class="col-sm-6 col-md-6 col-lg-6">Personnummer:</div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.UserSettings?.PersonalNumber}} </div>
                </div>
                <br /><br />

                <div class="row col-12 marginbottom15" *ngIf="subInvoice?.PensionSavingsAmount > 0">
                  <div class="col-sm-6 col-md-6 col-lg-6">Totalt till tjänstepension:</div> <div class="col-sm-6 col-md-6 col-lg-6"><b>{{ subInvoice?.PensionSavingsInclTax}}</b> ({{ subInvoice?.PensionSavingsAmount + '+' + subInvoice?.PensionSavingsTaxAmount}})</div>
                  <div class="col-sm-6 col-md-6 col-lg-6">Tjänstepensionsföretag:</div> <div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.UserSettings?.PensionSavingsSettings?.PensionSavingsCompany?.Name }}</div>                  
                </div>

                <div class="row col-12 marginbottom15">
                  <div class="col-sm-6 col-md-6 col-lg-6">Bank:</div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.UserSettings?.BankName }} </div>
                  <div class="col-sm-6 col-md-6 col-lg-6" *ngIf="subInvoice?.UserSettings?.ClearingNumber != '3300'">Clearing + kontonummer: </div><div class="col-sm-6 col-md-6 col-lg-6" *ngIf="subInvoice?.UserSettings?.ClearingNumber != '3300'">{{ subInvoice?.UserSettings?.ClearingNumber }} {{ subInvoice?.UserSettings?.AccountNumber }}</div>
                  <div class="col-sm-6 col-md-6 col-lg-6" *ngIf="subInvoice?.UserSettings?.ClearingNumber == '3300'">Personkonto: </div><div class="col-sm-6 col-md-6 col-lg-6" *ngIf="subInvoice?.UserSettings?.ClearingNumber == '3300'">{{ subInvoice?.UserSettings?.AccountNumber }}</div>
                  <div class="col-sm-6 col-md-6 col-lg-6">Totalt att betala ut:</div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.PayOutTotal }}</div>
                  <!--<div class="col-sm-6 col-md-6 col-lg-6">Text avsändarkonto: </div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.UserSettings?.EmploymentNumber }} {{ subInvoice?.InvoiceNumber }} </div>-->
                  <div class="col-sm-6 col-md-6 col-lg-6">Text avsändarkonto: </div><div class="col-sm-6 col-md-6 col-lg-6">{{ subInvoice?.UserSettings?.EmploymentNumber }} {{ invoice?.InvoiceNumber }}<span *ngIf="subInvoice.ExpressPayOut && invoice.ApprovedForExpress">x</span></div>

                  <div class="col-sm-6 col-md-6 col-lg-6">Text mottagarkonto: </div><div class="col-sm-6 col-md-6 col-lg-6">sam{{invoice?.InvoiceNumber}}</div>
                </div>
              </div>

              <div class="row col-lg-12" style="margin: 0 0 20px -15px">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field>
                    <input matInput [matDatepicker]="pickerPayment" [(ngModel)]="subInvoice.PayoutDate" (dateChange)="subInvoice.PayoutDate = toFormattedDate($event.value)" placeholder="Datum för utbetalning:">
                    <mat-datepicker-toggle matSuffix [for]="pickerPayment"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPayment></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <button *ngIf="subInvoice" color="accent" mat-flat-button (click)="updatePayoutDate(subInvoice.Id, subInvoice.PayoutDate)" [disabled]="isLoading || subInvoice.PayoutDate == null || subInvoice.HealthCareAmountExceedesLimit" style="float:right;">Spara datum</button>
                </div>
                <div *ngIf="subInvoice.ExpressPayOut && !invoice.ApprovedForExpress" style="color: red; font-size: 80%; padding-left: 15px; font-style: italic;">
                  Expressutbetalning är vald, men moderfakturan är ej bekräftad
                </div>
                <div *ngIf="subInvoice.ExpressPayOut && invoice.ApprovedForExpress" style="color: green; font-size: 80%; padding-left: 15px; font-style: italic;">
                  Expressutbetalning är vald, moderfakturan är bekräftad
                </div>
                <div [style.color]="(taxChangedThisMonth) ? 'red' : 'black'" style="font-size: 70%; padding-left: 15px; font-style: italic;">
                  <div [innerHTML]="lastPayoutMessage"></div>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    </div>

    <!--<div class="col-lg-12 col-sm-12" style="margin: 20px 0; float: left;">
      <button mat-flat-button color="accent" (click)="save(invoice)" [disabled]="isLoading" style="float:right;">Spara</button>
      <a href="#/transactions" class="link">Gå till Ekonomi</a>
    </div>-->
    </ng-container>

  </div>
</div>
